import { FC, useMemo, useCallback } from 'react';
import intl from 'react-intl-universal';
import { Option } from 'utils/customTypes';
import { ProjectPriority } from 'utils/types/projectsList';
import { PROJECT_PRIORITY } from 'utils/constants/projectsList';
import { FormItem, Dropdown } from '@getsynapse/design-system';

interface ProjectPriorityFilterProps {
  onSelect: (selected: ProjectPriority[]) => void;
  selected?: ProjectPriority[];
}

const ProjectPriorityFilter: FC<ProjectPriorityFilterProps> = ({
  selected,
  onSelect,
}) => {
  const priorityOptions = useMemo(() => {
    return Object.keys(PROJECT_PRIORITY).map((key) => ({
      value: PROJECT_PRIORITY[key as keyof typeof PROJECT_PRIORITY],
      label: intl.get(`PROJECT_DETAIL.PRIORITY_OPTIONS.${key}`),
    }));
  }, []);

  const selectedOptions = useMemo(() => {
    return priorityOptions.filter((option) =>
      selected?.includes(option.value as ProjectPriority)
    );
  }, [priorityOptions, selected]);

  const handleOnChange = useCallback(
    (selectedOptions: Option[]) => {
      const selectedValues = selectedOptions.map((option) => option.value);
      onSelect(selectedValues as ProjectPriority[]);
    },
    [onSelect]
  );

  return (
    <FormItem label={intl.get('PROJECT_DETAIL.PRIORITY')}>
      <Dropdown
        options={priorityOptions}
        values={selectedOptions}
        onChange={handleOnChange}
        multiple
        placeholder={intl.get('FILTER_GENERAL.PLACEHOLDER')}
        triggerProps={{
          'aria-label': 'project-priority-filter',
        }}
      />
    </FormItem>
  );
};

export default ProjectPriorityFilter;
